import React from 'react';
// import { Info } from 'lucide-react';
import PackageInclusions from './package_inclusions';
import PackageAddOns from '././package_addons';
import PackageImages from './package_images';

const PackageRow = ({ 
  pkg, 
  experiences, 
  onInfoClick, 
  onAddonClick 
}) => {
  return (
    <div className="package-row">
      <div className="row-image">
        {pkg.images.length > 1 && (
          <img 
            src={pkg.images[1]} 
            alt={pkg.title}
            onError={(e) => e.target.src = '/img/datlogoA.png'}
          />
        )}
      </div>
      
      <div className="row-content">
        <div className="title-row">
          {pkg.images.length > 0 && (
            <img 
              src={pkg.images[0]} 
              alt={pkg.title}
              onError={(e) => e.target.src = '/img/datlogoA.png'}
            />
          )}
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <h3>{pkg.title}</h3>
            {/* {pkg.description && (
              <Info 
                className="info-icon" 
                size={20} 
                onClick={() => onInfoClick(pkg)}
                style={{ cursor: 'pointer' }}
              />
            )} */}
          </div>
        </div>
        
        <PackageInclusions inclusions={pkg.inclusions} />
      </div>
      
      <div className="row-extras">
        <PackageAddOns 
          addOns={pkg.addOns}
          experiences={experiences}
          onAddonClick={onAddonClick}
        />
        <PackageImages images={pkg.images} title={pkg.title} />
      </div>
    </div>
  );
};

export default PackageRow;